/** Ключ источника в слайсах окна «Собственной»: один и тот же идентификатор в любом регистре — один источник. */
export const ownResourceKey = (resourceId: string): string => resourceId.trim().toLowerCase()
